import script from "./ActsStatusBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActsStatusBar.vue?vue&type=script&setup=true&lang=ts"

import "./ActsStatusBar.vue?vue&type=style&index=0&id=08162c38&lang=scss"

const __exports__ = script;

export default __exports__